import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postPetFormOneStart,
  postPetFormOneSuccess,
  postPetFormOneDataSuccess,
  postPetFormOneFailure,
} from "../reducers/postPetFormOneReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postPetFormOne = createAsyncThunk(
  "postPetFormOne",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postPetFormOneStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Petinsurance/SaveClientDetails`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postPetFormOneSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postPetFormOneDataSuccess(values));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postPetFormOneFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postPetFormOneFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postPetFormOneFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
